module.exports = __webpack_public_path__ + "img/T2B_rc_18.9e453970.png";